import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdVerifiedUser } from "react-icons/md";
import { getDateAndTimeFormatted } from "../../../utils/commonFunctions";
import "../../style.css";
import "./style.css";
import CustomModal from "../../../components/customModal";
import { queryStatusHandler } from "../actions";
import { useDispatch } from "react-redux";

const QueryDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const queryData = location.state?.queryData;
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();

  const modalClose = () => {
    setModal(false);
  };

  const isActiveHandler = () => {
    console.log("active handler called");
    dispatch(
      queryStatusHandler(queryData?._id, (response) => {
        console.log("response", response);
        navigate("/queries");
      })
    );
    modalClose();
  };

  const renderModalBody = () => {
    return (
      <p className="text-center pt-2">
        Are you sure want to marked as{" "}
        <span className="highlight--text">Completed</span>?
      </p>
    );
  };
  
  return (
    <div className="user-details-main-container justify-content-between">
      <div className="personal-info-container query-details-container">
        <h4 className="label-text heading text-underline">Query Information</h4>

        <div className="info-child-container">
          <div className="info-sub-child-container">
            <p className="non-label-text">Name</p>
            <p className="label-text info-text">{queryData?.name || "N/A"}</p>
          </div>
          <div className="info-sub-child-container">
            <p className="non-label-text">Date</p>
            <p className="label-text info-text">
              {getDateAndTimeFormatted(queryData?.createdAt) || "N/A"}
            </p>
          </div>
        </div>

        <div className="info-child-container">
          <div className="info-sub-child-container">
            <p className="non-label-text">Email Address</p>
            <p className="label-text info-text">{queryData?.email || "N/A"}</p>
          </div>
          <div className="info-sub-child-container">
            <p className="non-label-text">Status</p>
            <p
              className={`label-text info-text ${queryData?.status === 1 ? "text-warning" : "text-success"}`}
            >
              {queryData?.status === 1 ? "Pending" : "Completed"}
            </p>
          </div>
        </div>

        <div className="query-field-container">
          <p className="non-label-text">Query</p>
          <p className="label-text info-text query-text-area">
            {queryData?.description || "N/A"}
          </p>
        </div>
      </div>

      <CustomModal
        visible={modal}
        visibleHandler={modalClose}
        heading={"Confirmation"}
        body={renderModalBody}
        confirmHandler={() =>
          isActiveHandler(queryData?._id, queryData?.status)
        }
        modalSize="md"
        confirmText={"Yes, Completed"}
        footershow={true}
        closeText="Cancel"
      />
      <div>
        {queryData?.status && (
          <div
            style={{
              cursor: queryData?.status === 1 ? "pointer" : "not-allowed",
            }}
            {...(queryData?.status === 1 && {
              onClick: () => setModal(true),
            })}
            className={`site-details-btns ${queryData?.status === 4 ? "site-success-btn" : "site-warning-btn"}`}
          >
            {queryData?.status === 1
              ? "Pending (mark as Completed)"
              : "Completed"}
            <MdVerifiedUser className="lg-icon" />
          </div>
        )}
      </div>
    </div>
  );
};

export default QueryDetails;
